import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getOrderIsLoyaltyInternationalTrip from './getOrderIsLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { getViewedOrder } from 'selectors/orderSelectors'
import getIsTasteOfGoldEligibleOrder from './getIsTasteOfGoldEligibleOrder'
import getLoyaltyEligibleTransferOptions from './getLoyaltyEligibleTransferOptions'
import { hasConfiguredHomeToAirportOption } from 'loyalty/lib/transferOfferUtils'
import {
  canUseAirportTransferBenefit,
  hasIssuedLoyaltyBenefit,
} from 'loyalty/lib/airportTransferBenefitUtils'
import { orderHasLoyaltyBenefitEligibleTravel } from 'loyalty/lib/isLoyaltyBenefitEligibleTravel'

const getOrderCanRedeemTransferLoyaltyBenefit = createSelector(
  (state: App.State) => getViewedOrder(state),
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => state.loyalty.account.data?.tier,
  (state: App.State) => state.loyalty.config,
  (state: App.State) => getOrderIsLoyaltyInternationalTrip(state),
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => state.loyalty.config?.transferAirports ?? EmptyArray,
  (state: App.State) => getIsTasteOfGoldEligibleOrder(state),
  (state: App.State) => getLoyaltyEligibleTransferOptions(state),
  (
    viewedOrder,
    userBenefits,
    accountTier,
    loyaltyConfig,
    isInternationalTrip,
    isCurrentRegionUserLoyaltyRegion,
    airportCodes,
    isTasteOfGoldEligibleOrder,
    loyaltyEligibleTransferOptions,
  ): boolean => {
    if (!viewedOrder?.isBookingOwner) return false

    const hasHomeToAirportOption = hasConfiguredHomeToAirportOption(loyaltyConfig)
    const hasLoyaltyTransferOptions = loyaltyEligibleTransferOptions.canUseOneWay ||
      loyaltyEligibleTransferOptions.canUseReturn ||
      hasHomeToAirportOption

    const orderTier = viewedOrder?.loyaltyDetails.tier

    if (
      !isCurrentRegionUserLoyaltyRegion ||
      !orderTier ||
      !hasLoyaltyTransferOptions ||
      !orderHasLoyaltyBenefitEligibleTravel(viewedOrder)
    ) {
      return false
    }

    if (hasIssuedLoyaltyBenefit(viewedOrder, 'airport_transfer')) return false

    const hasTransferEntitlement = canUseAirportTransferBenefit({
      userBenefits,
      loyaltyConfig,
      accountTier,
      isTasteOfGoldEligible: isTasteOfGoldEligibleOrder,
    })

    return (
      airportCodes.length > 0 &&
      hasTransferEntitlement &&
      isInternationalTrip
    )
  },
)

export default getOrderCanRedeemTransferLoyaltyBenefit
